import React from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const EscritoriosEscolaresIntro = () => {
  return (
    <section>
      <div className="container">
        <div className="row g-xxl-5 align-items-end mt-n1-9">
          {/* Columna izquierda con imagen y características */}
          <div className="col-lg-6 order-2 order-lg-1 mt-1-9">
            <div className="pe-lg-1-6 pe-xl-6">
              <img src="/assets/img/productos/escritorios-escolares/escritorios-escolares-intro-1.jpg" alt="escritorios escolares" className="mb-6 mb-xl-10" />
              <div className="ps-lg-10 ps-xl-20">
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="El pupitre se puede inclinar"
                  descripcion="El escritorio se puede inclinar de 0 a 40° grados. para proporcionar el ángulo óptimo para realizar sus tareas, escribir, leer o dibujar, lo que evita el encorvamiento. El tope anticaída evita que los objetos se caigan mientras está inclinado."
                />
                <FeatureItem
                  imgSrc="/assets/img/icons/icon-flecha-derecha.png"
                  titulo="Fácilmente ajustable"
                  descripcion="Tanto el escritorio como la silla son ajustables en altura, conforme vayan creciendo podrás ir ajustando la posición del escritorio a su estatura."
                />
              </div>
            </div>
          </div>
          
          {/* Columna derecha con título y párrafo */}
          <div className="col-lg-6 order-1 order-lg-2 mt-1-9">
            <div className="ps-lg-1-6 ps-xl-6">
              <div className="title-style1 mb-1-9 mb-lg-10 mb-xl-15">
                <span>Ajustable, cómodo, moderno y resistente</span>
                <h2 className="h1 mb-4">Divertido escritorio para niñas y niños </h2>
                <p className="mb-0">
                Tus hijos podrán sentarse cómodamente y con una posición corporal adecuada para mantener una buena salud. Las áreas ligeramente contorneadas de la silla siguen las curvas naturales de los muslos mejorando la circulación sanguínea.
                </p>
              </div>
              <img src="/assets/img/productos/escritorios-escolares/escritorios-escolares-intro-2.jpg" alt="piso de pvc rigido amarillo" /> 
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para las características individuales
const FeatureItem = ({ imgSrc, titulo, descripcion }) => {
  return (
    <div className="d-flex border-bottom pb-1-9 mb-1-9">
      <div className="flex-shrink-0 me-4">
        <img src={imgSrc} alt={titulo} />
      </div>
      <div className="flex-grow-1">
        <h4 className="h5">{titulo}</h4>
        <p className="mb-0">{descripcion}</p>
      </div>
    </div>
  );
};

export default EscritoriosEscolaresIntro;